/**
 * GLOBAL EXPORT (CSV slice) — client-side, real, and it works right now
 * with no backend: it serializes exactly the rows/columns passed in, so
 * it always respects whatever filtering a module already applied. PDF/XLSX
 * with branding (per brief #17) need a real export service and are NOT
 * implemented here — this is the one export format honestly buildable
 * without a backend tonight.
 */
export interface CsvColumn<T> {
  key: string;
  header: string;
  value: (row: T) => string | number;
}

// No `extends Record<string, unknown>` constraint: plain entity interfaces
// like Creator (types/entities.ts) declare fixed named properties, not an
// index signature, so under strict mode TS refuses to assign them to a
// `Record<string, unknown>`-constrained generic even though every property
// this function touches comes through `columns[].value(row)`, never a
// dynamic `row[key]` lookup. The function never actually needs an index
// signature — it only needs *some* object type — so the honest fix is
// dropping the constraint, not widening it with `any`/`as any`.
export function exportRowsToCsv<T>(
  filename: string,
  rows: T[],
  columns: CsvColumn<T>[]
) {
  const escape = (v: string | number) => {
    const s = String(v ?? '');
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map((c) => escape(c.header)).join(',');
  const lines = rows.map((row) => columns.map((c) => escape(c.value(row))).join(','));
  const csv = [header, ...lines].join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' }); // BOM so Arabic renders correctly in Excel
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
